import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fabullseye, faEye, faArrowRight, faCheckCircle } from "@fortawesome/free-solid-svg-icons"; // Assurez-vous d'avoir ces icônes
import { faBullseye } from "@fortawesome/free-solid-svg-icons";
import "./AboutUs.css"; // Nouveau fichier CSS

const AboutUs = () => {
  const { t } = useTranslation();

  // Scroll to top au chargement
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* --- HERO SECTION --- */}
      <section className="about-hero-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <span className="badge bg-soft-primary text-primary px-3 py-2 rounded-pill fw-bold mb-3 wow animate__animated animate__fadeInUp">
                Cible RH Emploi
              </span>
              <h1 className="display-4 fw-bold dl mb-4 wow animate__animated animate__fadeInUp" data-wow-delay="0.1s">
                Votre partenaire <span className="text-danger">Stratégique</span> en Ressources Humaines.
              </h1>
              <p className="lead text-muted mb-4 wow animate__animated animate__fadeInUp" data-wow-delay="0.2s">
                Nous connectons les talents aux opportunités et accompagnons les entreprises vers l'excellence.
              </p>
            </div>
            <div className="col-lg-6 text-center wow animate__animated animate__fadeInRight" data-wow-delay="0.3s">
                <div className="hero-image-wrapper">
                    <img
                        src="/assets/imgs/page/provided/22.png"
                        alt="Cible RH Team"
                        className="img-fluid rounded-4 shadow-lg"
                    />
                    {/* Élément décoratif flottant */}
                    <div className="floating-card bg-white p-3 rounded-3 shadow">
                        <div className="d-flex align-items-center">
                            <div className="icon-box bg-primary text-white me-3">
                                <FontAwesomeIcon icon={faCheckCircle} />
                            </div>
                            <div>
                                <h6 className="mb-0 fw-bold">Expertise Reconnue</h6>
                                <small className="text-muted">Depuis des années</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- SECTION HISTOIRE / PRESENTATION --- */}
      <section className="section-box mt-80 mb-50">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-5 mb-lg-0 wow animate__animated animate__fadeInLeft">
              <div className="image-stack-container">
                 <img
                    src="/assets/imgs/page/provided/20.png"
                    className="img-fluid rounded-4 shadow-lg position-relative z-2"
                    alt="Notre histoire"
                 />
                 {/* Image d'arrière plan décorative si dispo, sinon cercle */}
                 <div className="circle-bg"></div>
              </div>
            </div>
            <div className="col-lg-6 wow animate__animated animate__fadeInRight">
              <div className="ps-lg-5">
                <h2 className="section-title mb-20 text-dark fw-bold">
                    {t("texts")}
                </h2>
                <div className="content-text text-muted">
                    <p className="mb-3" dangerouslySetInnerHTML={{__html: t("textaboutf")}}></p>
                    <p className="mb-3">{t("textaboutT")}</p>
                    <p className="mb-4">{t("textaboutr")}</p>
                </div>
                
                <a
                  href="https://www.ciblerh-emploi.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-primary btn-lg rounded-pill px-5 shadow-sm hover-up"
                >
                  {t("textMoreDetails") || "En savoir plus"}
                  <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- SECTION MISSION & VISION (Cartes) --- */}
      <section className="section-box mt-50 mb-80 bg-light py-5">
        <div className="container">
            <div className="text-center mb-60">
                <h2 className="fw-bold mb-15 wow animate__animated animate__fadeInUp">Nos Valeurs Fondamentales</h2>
                <p className="text-muted font-lg wow animate__animated animate__fadeInUp" data-wow-delay="0.1s">
                    Ce qui nous guide au quotidien pour vous servir.
                </p>
            </div>

            <div className="row g-4">
                {/* Carte Vision */}
                <div className="col-md-6 wow animate__animated animate__fadeInUp" data-wow-delay="0.2s">
                    <div className="value-card h-100 bg-white p-5 rounded-4 shadow-sm border-0 position-relative overflow-hidden">
                        <div className="card-bg-icon">
                            <FontAwesomeIcon icon={faEye} />
                        </div>
                        <div className="icon-wrapper mb-4 text-primary">
                            <FontAwesomeIcon icon={faEye} size="2x" />
                        </div>
                        <h3 className="h4 fw-bold mb-3" dangerouslySetInnerHTML={{__html: t("textv")}}></h3>
                        <p className="text-muted mb-0">
                            {t("textvision")} <br/> {t("textvision2")}
                        </p>
                    </div>
                </div>

                {/* Carte Mission */}
                <div className="col-md-6 wow animate__animated animate__fadeInUp" data-wow-delay="0.4s">
                    <div className="value-card h-100 bg-white p-5 rounded-4 shadow-sm border-0 position-relative overflow-hidden">
                        <div className="card-bg-icon">
                            <FontAwesomeIcon icon={faBullseye} />
                        </div>
                        <div className="icon-wrapper mb-4 text-danger">
                            <FontAwesomeIcon icon={faBullseye} size="2x" />
                        </div>
                        <h3 className="h4 fw-bold mb-3" dangerouslySetInnerHTML={{__html: t("textm")}}></h3>
                        <p className="text-muted mb-0">
                            {t("textmission1")}
                        </p>
                    </div>
                </div>
            </div>
        </div>
      </section>

      {/* --- SECTION IMAGES GALLERIE (Optionnel, pour utiliser les autres images) --- */}
      <section className="section-box mb-80">
          <div className="container">
              <div className="row g-3">
                  <div className="col-md-8 wow animate__animated animate__fadeInLeft">
                      <img src="/assets/imgs/page/provided/21.png" alt="Team Work" className="img-fluid rounded-4 w-100 object-fit-cover shadow-sm" style={{height: '400px'}} />
                  </div>
                  <div className="col-md-4 wow animate__animated animate__fadeInRight">
                      <img src="/assets/imgs/page/provided/13.png" alt="Office" className="img-fluid rounded-4 w-100 object-fit-cover shadow-sm" style={{height: '400px'}} />
                  </div>
              </div>
          </div>
      </section>

    </>
  );
};

export default AboutUs;